import { Directive, inject, ResourceRef, signal } from '@angular/core';
import { GridResource, GridService } from '@unity/services/grid.service';
import { GridifyQuery, Paging, UnityDto } from '@unity/utils/types';

@Directive() // See https://github.com/angular/angular/issues/37769
export abstract class AbstractGridComponent<TDto extends Readonly<UnityDto>> {
  private readonly gridService = inject(GridService);

  #gridResource?: GridResource<TDto>;

  protected abstract readonly resource: ResourceRef<Paging<TDto> | undefined>;

  private get gridResource() {
    this.#gridResource ??= this.gridService.resourceForGrid(this.resource);
    return this.#gridResource;
  }

  protected get $gridData() {
    return this.gridResource.$data;
  }

  protected get $gridLoading() {
    return this.gridResource.$loading;
  }

  protected get $gridError() {
    return this.gridResource.$error;
  }

  protected readonly $gridifyQuery = signal<GridifyQuery | undefined>(undefined);

  protected onDataQuery(e: GridifyQuery) {
    this.$gridifyQuery.set(e);
  }
}
